export const displayText = (value: unknown, fallback = "") => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string" || typeof value === "number")
    return String(value);
  if (typeof value === "object") {
    const candidate = value as Record<string, unknown>;
    const namedValue =
      candidate.name || candidate.displayName || candidate.label;
    if (typeof namedValue === "string" || typeof namedValue === "number")
      return String(namedValue);
    const id = candidate._id || candidate.id;
    if (typeof id === "string" || typeof id === "number") return String(id);
  }
  return fallback;
};
